module.exports = __webpack_public_path__ + "media/images/cover/apartment-ab14815e59a90f2b0d22661e9345ca3c.jpg";